function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".ea389fbd-53b4-4b69-9775-063ff73e595e{fill:#282828;}"));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "bbd86ce5-a932-453f-8137-615d46a28a28",
  "data-name": "Ebene 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "bb0a13a7-0119-4c19-8b10-c082a8c155eb",
  "data-name": "footre"
}, /*#__PURE__*/React.createElement("circle", {
  className: "ea389fbd-53b4-4b69-9775-063ff73e595e",
  cx: 4.5,
  cy: 4.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "ea389fbd-53b4-4b69-9775-063ff73e595e",
  cx: 4.5,
  cy: 20.13,
  r: 4.5
}), /*#__PURE__*/React.createElement("circle", {
  className: "ea389fbd-53b4-4b69-9775-063ff73e595e",
  cx: 4.5,
  cy: 35.76,
  r: 4.5
})));

const SvgSidemenu = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 9 40.26",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSidemenu, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sidemenu.e7f837cf.svg";
export { ForwardRef as ReactComponent };